export const GET_FULL_PDF = 'GET_FULL_PDF'
export const GET_FULL_PDF_SUCCESS = 'GET_FULL_PDF_SUCCESS'
export const GET_FULL_PDF_FAILED = 'GET_FULL_PDF_FAILED'
